var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"subtitle-1 black--text"},[_vm._v(_vm._s(_vm.value))]),_c('div',{staticClass:"data-cell-label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }